// Pure display/total calculations for useDonationForm, extracted VERBATIM.
export const formatCurrency = (amount) => {
  return parseFloat(amount || 0).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export const calculateTotal = ({
  donationType,
  preservedOneTimeAmount,
  oneTimeAmount,
  preservedMonthlyAmount,
  monthlyAmount,
  preservedIsForever,
  isForever,
  preservedNumberOfPayments,
  numberOfPayments,
}) => {
  if (donationType === 'one-time') {
    const amount = preservedOneTimeAmount || parseFloat(oneTimeAmount) || 0;
    return amount.toFixed(2);
  } else {
    // Monthly donation - show total over all payments
    // Use preserved values if available (they persist even if form values are cleared)
    const amount = preservedMonthlyAmount || parseFloat(monthlyAmount) || 0;
    const forever = preservedIsForever || isForever;

    if (forever) {
      // For forever subscriptions, we can't calculate a total
      return null;
    }

    const payments = preservedNumberOfPayments || numberOfPayments;
    if (amount && payments) {
      const numPayments = typeof payments === 'number' ? payments : parseInt(payments);
      return (amount * (numPayments || 0)).toFixed(2);
    }
    return amount.toFixed(2);
  }
};
